import { Helmet } from '@dr.pogodin/react-helmet';
import { useApiRead } from 'api-read-hook';
import { useParams } from 'react-router-dom';
import { css } from 'react-strict-dom';

import {
  Box,
  PageError,
  PageLoading,
  PageWrap,
  RouterLink,
  Text,
} from '../../components';
import { useSelectedCompany } from '../../contexts/ClientDataContext';

export default function DataSetsPage() {
  const { companySlug } = useParams<{ companySlug: string }>();
  const selectedCompany = useSelectedCompany();

  const api = useApiRead<Array<{ slug: string; name: string }>>(
    `/company-data/set/${companySlug}/_list`
  );

  if (api.error) return <PageError {...api} />;

  const inner = api.data ? (
    <Box title="Data Sets">
      {api.data.map((dataSet) => (
        <RouterLink
          key={dataSet.slug}
          to={`/company/${companySlug}/bi/data/${dataSet.slug}`}
          style={{ display: 'block' }}
        >
          <Text as="div" style={styles.boxLink}>
            {dataSet.name}
          </Text>
        </RouterLink>
      ))}
    </Box>
  ) : (
    <PageLoading />
  );

  return (
    <PageWrap>
      <Helmet>
        <title>{`Data Sets | ${selectedCompany.name}`}</title>
      </Helmet>
      {inner}
    </PageWrap>
  );
}

const styles = css.create({
  boxLink: {
    display: 'block',
    paddingBlock: 20,
    paddingInline: 25,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#eee',
    transition: 'background-color 0.25s',
    ':hover': {
      backgroundColor: '#fafafa',
    },
  },
});
